module.exports = __webpack_public_path__ + "static/media/drommerian.7822bf14.png";